module.exports = __webpack_public_path__ + "static/media/bathroom_yellow.d4ee65e1.jpg";